import { BasePageProps, BasePageState, basePageInitialState } from '../BasePage'

import { store } from '../../redux/store'

import { createReducer, createAction } from '@reduxjs/toolkit'

export interface TravelPageProps extends BasePageProps {}

type TravelState = {
    tipo_viaggio: string | undefined
    destinazione: string | undefined
    data_inizio: string | undefined
    data_fine: string | undefined
    durata: string | undefined
    soggetti: string | undefined
    eta: number | undefined
    eta_assicurato_1: number | undefined
    eta_assicurato_2: number | undefined
    numero_figli: string | undefined
    numero_partecipanti: number | undefined
    eta_partecipanti: string | undefined
    tipo_copertura: string | undefined

    tipo_viaggioError: string | undefined
    destinazioneError: string | undefined
    data_inizioError: string | undefined
    data_fineError: string | undefined
    durataError: string | undefined
    soggettiError: string | undefined
    etaError: string | undefined
    eta_assicurato_1Error: string | undefined
    eta_assicurato_2Error: string | undefined
    numero_figliError: string | undefined
    numero_partecipantiError: string | undefined
    eta_partecipantiError: string | undefined
    tipo_coperturaError: string | undefined

    tipo_coperture: any
    tipo_destinazioni: any
    tipo_durate: any
    tipo_numero_figli: any
    tipo_persone: any
    tipo_viaggi: any
}

export type TravelPageState = TravelState & BasePageState

export const travelPageInitialState: TravelPageState = {    
    ...basePageInitialState,
    ...{
        tipo_viaggio: undefined,
        destinazione: undefined,
        data_inizio: undefined,
        data_fine: undefined,
        durata: undefined,
        soggetti: undefined,
        eta: undefined,
        eta_assicurato_1: undefined,
        eta_assicurato_2: undefined,
        numero_figli: undefined,
        numero_partecipanti: undefined,
        eta_partecipanti: undefined,
        tipo_copertura: undefined,

        tipo_viaggioError: undefined,
        destinazioneError: undefined,
        data_inizioError: undefined,
        data_fineError: undefined,
        durataError: undefined,
        soggettiError: undefined,
        etaError: undefined,
        eta_assicurato_1Error: undefined,
        eta_assicurato_2Error: undefined,
        numero_figliError: undefined,
        numero_partecipantiError: undefined,
        eta_partecipantiError: undefined,
        tipo_coperturaError: undefined,

        tipo_coperture: undefined,
        tipo_destinazioni: undefined,
        tipo_durate: undefined,
        tipo_numero_figli: undefined,
        tipo_persone: undefined,
        tipo_viaggi: undefined,
    }
}

export const travelUpdate = createAction<TravelPageState>('travel/update')

export const travelReducer = createReducer ( 
    travelPageInitialState,
    (builder) => {
        builder.addCase(travelUpdate, (state, action) => {
            return action.payload as TravelPageState
        })
    }
)

export type TravelRootState = ReturnType<typeof store.getState>
export type TravelDispatch = typeof store.dispatch